import React from 'react';
import { Modal, FormInput, Button } from '@/components/ui';

export const CreateConversationModal = ({
  isOpen,
  onClose,
  newContact,
  setNewContact,
  handleCreateConversation,
  isCreating,
  templates = []
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="New Conversation"
      size="md"
    >
      <form onSubmit={handleCreateConversation} className="flex flex-col gap-5">
        <div className="flex flex-col gap-1">
          <p className="text-sm text-gray-500 mb-2">Start a new WhatsApp conversation with a customer.</p>
        </div>
        <FormInput
          label="Customer Name"
          placeholder="e.g. John Doe"
          value={newContact.name}
          onChange={(e) => setNewContact({ ...newContact, name: e.target.value })}
        />
        <FormInput
          label="Phone Number"
          required
          type="tel"
          placeholder="+1234567890 (Include country code)"
          value={newContact.phone}
          onChange={(e) => setNewContact({ ...newContact, phone: e.target.value })}
        />
        
        {templates.length > 0 && (
          <div className="flex flex-col gap-2">
            <label className="text-sm font-medium text-gray-700">Send Template (Optional)</label>
            <select
              className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 bg-white sm:text-sm text-gray-900"
              value={newContact.templateName || ''}
              onChange={(e) => setNewContact({ ...newContact, templateName: e.target.value })}
            >
              <option value="">-- Do not send template --</option>
              {templates.map(t => (
                <option key={t.name} value={t.name}>
                  {t.name.replace(/_/g, ' ')} ({t.language})
                </option>
              ))}
            </select>
            <p className="text-xs text-gray-500">
              Select a pre-approved template to send immediately. Useful for initiating a chat outside the 24-hour window.
            </p>
          </div>
        )}

        <div className="flex gap-3 mt-4">
          <Button variant="outline" className="flex-1" onClick={onClose} type="button">
            Cancel
          </Button>
          <Button type="submit" variant="orange" className="flex-1" loading={isCreating} disabled={isCreating}>
            Create Chat
          </Button>
        </div>
      </form>
    </Modal>
  );
};
